<template>
  <div class="filter-status-check">
    <div class="filter-status-check__btn">
      <span>已选中 {{checkTask.length}} 项</span>
      <span class="btnHover" :class="{'disabled': checkTask.length === 0}" @click="arch"><i class="icon iconfont iconicon_move"></i>归档</span>
      <span class="btnHover" :class="{'disabled': checkTask.length === 0}" @click="unArch"><i class="icon iconfont iconicon_restore"></i>恢复未归档</span>
      <span class="btnHover" :class="{'disabled': checkTask.length === 0}" @click="remove"><i class="icon iconfont iconicon_recycle_bin"></i>移至回收站</span>
      <span class="btnHover"  @click="exit"><i class="icon iconfont iconicon_close1"></i>退出</span>
    </div>
    <div class="filter-status-check__alert" v-if="alertShow">
      <p class="title">提示</p>
      <p class="content">进入批量选择，点击【任务】或【全选】选择任务后，在底部【工具栏】可对任务进行批量操作。</p>
      <p class="footer">
        <wf-button @click="ink">我知道了</wf-button>
      </p>
    </div>
  </div>
</template>
<script>
import { Storage } from '@/utils/utils'
import { mapMutations, mapState } from 'vuex'
import api from '@/services/api/task/task'
import bus from '@/bus'
export default {
  data() {
    return {
      alertShow: false,
    }
  },
  computed: {
    ...mapState('task/task', {
      checkTask: state => state.checkTask
    })
  },
  created() {
    this.clear_checkTask()
    this.alertShow = !Storage.get('alertShow')
  },
  methods: {
    ...mapMutations('task/task', ['clear_checkTask','set_checkStatus']),
    ink() {
      this.alertShow = false
      Storage.set('alertShow', 1)
    },
    exit() {
      this.set_checkStatus(false)
      bus.$emit('clear_check')
    },
    async arch() {
      await this.$wfAlert('warning', '确认归档此任务？', '归档后的任务，将不可再编辑。你可以重新激活将任务恢复，进行编辑。', '归档任务')
      await api.batchUpdateTaskStage({task_ids: this.checkTask, task_stage: '已归档'})
      this.exit()
      bus.$emit('updateTask')
    },
    async unArch() {
      await this.$wfAlert('warning', '确认恢复未归档该任务吗？', '恢复未归档该项目后，任务将恢复到未归档状态，可进行编辑。', '恢复未归档')
      await api.batchUpdateTaskStage({task_ids: this.checkTask, task_stage: '进行中'})
      this.exit()
      bus.$emit('updateTask')
    },
    async remove() {
      await this.$wfAlert('warning', '确认删除任务吗？', '删除后的任务，将不再出现在工作台，你可以在回收站中对该任务进行恢复。', '移到回收站')
      await api.batchDeleteTasks({taskIds: this.checkTask})
      this.exit()
      bus.$emit('updateTask')
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.filter-status-check {
  .filter-status-check__btn {
    width: 612px;
    height: 54px;
    position: fixed;
    bottom: 48px;
    left: 50%;
    transform: translate(-50%, 0);
    background-color: #fff;
    box-shadow: 0px 4px 16px 0px rgba(32,32,32,0.16);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    span {
      padding: 8px;
      font-size: 14px;
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-right: 9px;
      }
    }
    span:first-child {
      @include fontColorOpacity(.6);
    }
    .disabled {
      pointer-events: none;
      @include fontColorOpacity(.4);
      i {
        @include fontColorOpacity(.4);
      }
    }
  }
  .filter-status-check__alert {
    width: 370px;
    height: 202px;
    display: flex;
    flex-direction: column;
    padding: 24px;
    position: fixed;
    right: 24px;
    bottom: 40px;
    background-color: #fff;
    box-shadow: 0px 4px 16px 0px rgba(13,31,60,0.16);
    border-radius: 4px;
    border: 1px solid #EAEBEC;
    box-sizing: border-box;
    z-index: 100;
    .title {
      font-size: 18px;
      font-weight: 400;
    }
    .content {
      font-size: 14px;
      font-weight: 400;
      margin: 32px 0;
    }
    .footer {
      text-align: right;
    }
  }
}
</style>
